import { Button, Input, Steps, StepsProps } from "antd"
import { motion } from "framer-motion"
import { FC, HTMLAttributes, ReactNode } from "react"
import { Route, RouteProps } from "react-router"
import styled, { useTheme } from "styled-components"
export interface DivWithChildrenProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode // Specifies that children can be any valid React node
}
export interface SpanWithChildrenProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode // Specifies that children can be any valid React node
}

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
`
const HalfWidth = styled.div`
  width: 90%;
`

export const Container = styled.div`
  background-color: ${(props) => props.theme.white};
  padding: 10px 0px 20px;
  max-width: 800px;
  margin: auto;
`

export const ShortListContainer = styled.div`
  background-color: ${(props) => props.theme.white};
  padding: 1em 0px 20px;
  max-width: 40em;
  font-size: 1rem;

  /* text-align:center; */
  margin: auto;
`

export const MessageContainer = styled.div`
  background-color: ${(props) => props.theme.white};
  padding: 5em 0px 20px;
  max-width: 400px;
  margin: auto;
`
export const ShadowContainer = styled.div`
  padding: 30px;
  max-width: 800px;
  margin: auto;

  border-radius: 7px;
  border-style: solid;
  border-color: #f0f0f0;
  padding: 20px;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.5);
`

export const ContainerFull = styled.div`
  background-color: ${(props) => props.theme.white};

  padding: 10px 5% 20px;

  margin: auto;
`

export const Title = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 1.618rem;
  line-height: 27px;
  color: #555;
`

export const NormalText = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 20px;
  color: #555;
`

export const FullRow: FC<DivWithChildrenProps> = ({
  children,
  ...props
}: DivWithChildrenProps): JSX.Element => {
  return (
    <FlexContainer {...props}>
      <HalfWidth>{children}</HalfWidth>
    </FlexContainer>
  )
}

export const Padded = styled.div`
  width: 100%;
  padding: 10px;
`

export const RowInput = styled(Input)`
  width: 100%;
  padding: 10x;
  margin: 10px 0;
  height: 40px;
`

export const RowButton = styled(Button)`
  width: 100%;
  padding: 10x;
  margin: 10px 0;
  height: 40px;
`

export const GrayLabel = styled.div`
  color: gray;
  font-style: italic;
  margin-bottom: 0.5em;
`

interface LabeledBoxProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  children: ReactNode // Specifies that children can be any valid React node
  gray?: boolean
  border?: boolean
}
export const LabeledBox = ({
  title,
  children,
  gray,
  border,
  ...props
}: LabeledBoxProps): JSX.Element => {
  const theme = useTheme()
  return (
    <div
      style={{
        fontSize: "1rem",
        fontFamily: "'Ubuntu-Regular', 'Open Sans', sans-serif",
      }}
      {...props}
    >
      <div
        style={{ marginTop: "2em", marginBottom: "5px", color: theme.primary }}
      >
        <b>{title}</b>
      </div>
      <div
        style={
          gray
            ? {
                backgroundColor: theme.third,
                borderRadius: "7px",
                borderStyle: "solid",
                borderColor: "#f0f0f0",
                boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
              }
            : border
            ? {
                backgroundColor: theme.white,
                borderRadius: "7px",
                borderStyle: "solid",
                borderColor: "#f0f0f0",

                padding: "20px",
                boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
              }
            : { backgroundColor: theme.white }
        }
      >
        {children}
      </div>
    </div>
  )
}

export const Routewk = ({
  //Route with key
  path,
  children,
  ...props
}: RouteProps) => {
  return <Route key={path} path={path} element={children} {...props} />
}

export const FadeIn = ({
  //use with framer-motion to create animation
  children,
  time=0.5,
  ...props
}: {
  children: React.ReactNode
  time?:number
}) => {
  
  return (
    <div key={Math.random()} {...props}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: time }}
      >
        {children}
      </motion.div>
    </div>
  )
}

export const PrimaryRowButton = styled(Button)`
  width: 100%;
  padding: 10x;
  margin: 10px 0;
  height: 40px;

  background-color: ${(props) => props.theme.primary};
`

export const PrimaryButton = styled(Button)`
  background-color: ${(props) => props.theme.primary};
`

/* interface LabeledBoxProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  children: ReactNode // Specifies that children can be any valid React node
  gray?: boolean
  border?: boolean
} */
export const Steps2 = ({ ...props }: StepsProps): JSX.Element => {
  return (
    <Steps style={{ margin: "auto", marginTop: "15em" }} {...props}></Steps>
  )
  // const Steps2 = styled(Steps)`
  // `
}
